module.exports = __webpack_public_path__ + "img/Portrait-taped-Vivian.afb9eb2c.svg";